import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import styles from './alphabet.scss';
import CSSModules from 'react-css-modules';
import { getCurrentLanguage } from '../../../localData';
import settings from '../../../../config/settings';

const Alphabet = ({ personType }) => {
    const renderLinks = (links) => links.map(str => (
        <li key={str} styleName="item">
            <Link styleName="link" to={ `/${getCurrentLanguage()}/${personType}/${str}` }>{ str.charAt(0) }</Link>
        </li>
    ));

    return (
        <div>
            <ul className="is-visible-mobile" styleName="mobile-list">
                { renderLinks(settings.Person.alphabet.short) }
            </ul>
            <ul className="is-visible-tablet" styleName="tablet-list">
                { renderLinks(settings.Person.alphabet.full) }
            </ul>
        </div>
    )
};

Alphabet.propTypes = {
    personType: PropTypes.string.isRequired,
};

export default CSSModules(Alphabet, styles);


// WEBPACK FOOTER //
// ./app/components/Person/Alphabet/index.jsx